import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "tab-pane fade",
  id: "qp-rules",
  role: "tabpanel"
}
const _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass(`card pt-4 `)
}
const _hoisted_3 = { class: "card-header border-0" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = { class: "svg-icon svg-icon-3" }
const _hoisted_7 = {
  id: "kt_customer_view_payment_method",
  class: "card-body pt-0"
}
const _hoisted_8 = {
  class: "py-0",
  "data-kt-customer-payment-method": "row"
}
const _hoisted_9 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_10 = {
  class: "d-flex align-items-center collapsible rotate collapsed",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_payment_method_1",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_payment_method_1"
}
const _hoisted_11 = { class: "me-3" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = {
  class: "d-flex align-items-center collapsible rotate collapsed",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_payment_method_1",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_payment_method_1"
}
const _hoisted_14 = { class: "me-3" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { class: "d-flex my-3 ms-9" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  "data-bs-toggle": "tooltip",
  "data-bs-trigger": "hover",
  title: "",
  "data-bs-original-title": "Edit"
}
const _hoisted_19 = { class: "svg-icon svg-icon-3" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "svg-icon svg-icon-3" }
const _hoisted_22 = {
  class: "modal fade",
  id: "addRulesFromTemplate",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "modal-dialog modal-dialog-centered mw-850px" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = { class: "modal-header" }
const _hoisted_26 = {
  id: "closeQpRuleTemplateModal",
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_27 = { class: "svg-icon svg-icon-1" }
const _hoisted_28 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-7" }
const _hoisted_29 = { class: "d-flex flex-column mb-7" }
const _hoisted_30 = {
  key: 0,
  class: "row"
}
const _hoisted_31 = { class: "btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 mb-5" }
const _hoisted_32 = { class: "d-flex align-items-center me-2" }
const _hoisted_33 = { class: "form-check form-check-custom form-check-solid form-check-primary me-6" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "flex-grow-1" }
const _hoisted_36 = { class: "d-flex align-items-center fs-3 fw-bold flex-wrap" }
const _hoisted_37 = { class: "fw-semibold opacity-50" }
const _hoisted_38 = {
  key: 1,
  class: "row"
}
const _hoisted_39 = {
  key: 0,
  class: "text-center pt-15"
}
const _hoisted_40 = {
  class: "modal fade",
  id: "kt_modal_new_card",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_41 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_42 = { class: "modal-content" }
const _hoisted_43 = { class: "modal-header" }
const _hoisted_44 = {
  id: "closeQpModal",
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_45 = { class: "svg-icon svg-icon-1" }
const _hoisted_46 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-7" }
const _hoisted_47 = { class: "d-flex flex-column mb-7" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-6" }
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "col-6" }
const _hoisted_53 = { class: "fv-plugins-message-container" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = { class: "text-center pt-15" }
const _hoisted_56 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_new_address_submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-title" }, [
          _createElementVNode("h2", { class: "fw-bold mb-0" }, "QP Rules")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewQpRule && _ctx.addNewQpRule(...args))),
            class: "btn btn-sm btn-flex btn-light-primary me-2",
            "data-bs-toggle": "modal",
            "data-bs-target": "#addRulesFromTemplate"
          }, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
            ]),
            _cache[5] || (_cache[5] = _createTextVNode(" Add QP rules from template ", -1))
          ]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewQpRule && _ctx.addNewQpRule(...args))),
            class: "btn btn-sm btn-flex btn-light-primary",
            "data-bs-toggle": "modal",
            "data-bs-target": "#kt_modal_new_card"
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
            ]),
            _cache[6] || (_cache[6] = _createTextVNode(" Add new QP rule ", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vendor.QpRules?.sort((a, b) => a.Days - b.Days), (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "text-gray-800 fw-bold" }, "Days")
                    ], -1)),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(item.Days), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
                      _createElementVNode("div", { class: "text-gray-800 fw-bold" }, "Discount")
                    ], -1)),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(item.Discount.toTwoFractionDigits()) + " %", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: ($event: any) => (_ctx.updateQp(item)),
                    class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#kt_modal_new_card"
                  }, [
                    _createElementVNode("span", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                      ])
                    ])
                  ], 8, _hoisted_17),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: ($event: any) => (_ctx.deleteQpRule(item.Id)),
                    class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
                    "data-bs-toggle": "tooltip",
                    title: "",
                    "data-kt-customer-payment-method": "delete",
                    "data-bs-original-title": "Delete"
                  }, [
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                    ])
                  ], 8, _hoisted_20)
                ])
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("div", {
                id: "kt_customer_view_payment_method_1",
                class: "fs-6 ps-10 collapse",
                "data-bs-parent": "#kt_customer_view_payment_method",
                style: {}
              }, null, -1))
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "separator separator-dashed" }, null, -1))
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[12] || (_cache[12] = _createElementVNode("h2", null, "Add QP rules from templates", -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("span", _hoisted_27, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_Form, {
              id: "addRulesFromTemplate_form",
              class: "form"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_29, [
                  (_ctx.templatesStore?.QpRuleTemplates?.length !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templatesStore.QpRuleTemplates, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "col-6",
                            key: index
                          }, [
                            _createElementVNode("label", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("input", {
                                    class: "form-check-input qpRuleTemplateRadio",
                                    type: "radio",
                                    name: "template",
                                    value: item.Id
                                  }, null, 8, _hoisted_34)
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("h2", _hoisted_36, _toDisplayString(item?.Name), 1),
                                  _createElementVNode("div", _hoisted_37, "Total Options Count " + _toDisplayString(item?.QpRuleTemplateOptions?.length), 1)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("div", { class: "col-12" }, [
                          _createElementVNode("div", { class: "alert alert-danger p-5 text-center" }, [
                            _createElementVNode("h4", { class: "mb-1 text-dark" }, "No Data")
                          ])
                        ], -1)
                      ]))]))
                ]),
                (_ctx.templatesStore?.QpRuleTemplates?.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitAdditionQpRulesFromTemplate && _ctx.submitAdditionQpRulesFromTemplate(...args))),
                        type: "button",
                        id: "addRulesFromTemplate_submit",
                        class: "btn btn-primary"
                      }, [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("span", { class: "indicator-label" }, " Submit ", -1),
                        _createElementVNode("span", { class: "indicator-progress" }, [
                          _createTextVNode(" Please wait... "),
                          _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
                        ], -1)
                      ]))])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _cache[15] || (_cache[15] = _createElementVNode("h2", null, "Qp Rule Form", -1)),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("span", _hoisted_45, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_Form, {
              onSubmit: _ctx.submitQpRules,
              "validation-schema": _ctx.validationSchema,
              id: "kt_modal_new_card_form",
              class: "form"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semobold form-label mb-2" }, [
                        _createElementVNode("span", { class: "required" }, "Days"),
                        _createElementVNode("i", {
                          class: "fas fa-exclamation-circle ms-2 fs-7",
                          "data-bs-toggle": "tooltip",
                          title: "Specify a card holder's name"
                        })
                      ], -1)),
                      _createVNode(_component_Field, {
                        id: "qpDays",
                        onInput: _cache[3] || (_cache[3] = event => _ctx.handleDaysChange(_ctx.qpRule?.Id, event.target.value)),
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: "",
                        name: "qpDays",
                        modelValue: _ctx.qpRule?.Days
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_ErrorMessage, { name: "qpDays" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semobold form-label mb-2" }, [
                        _createElementVNode("span", { class: "required" }, "Discount"),
                        _createElementVNode("i", {
                          class: "fas fa-exclamation-circle ms-2 fs-7",
                          "data-bs-toggle": "tooltip",
                          title: "Specify a card holder's name"
                        })
                      ], -1)),
                      _createVNode(_component_Field, {
                        id: "qpDiscount",
                        onInput: _cache[4] || (_cache[4] = event => _ctx.handleDiscountChange(_ctx.qpRule?.Id, event.target.value)),
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: "",
                        name: "qpDiscount",
                        modelValue: _ctx.qpRule?.Discount
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_ErrorMessage, { name: "qpDiscount" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("button", _hoisted_56, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("span", { class: "indicator-label" }, " Submit ", -1),
                    _createElementVNode("span", { class: "indicator-progress" }, [
                      _createTextVNode(" Please wait... "),
                      _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
                    ], -1)
                  ]))], 512)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ])
      ])
    ])
  ]))
}